import { useEffect, useState, useRef } from "react";
import TabsComponent from "../../../../../components/NewTabs";
import { Grid, Typography, Button, Tooltip } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import upgrade_license from '../../../../../asset/image/upgrade_license.svg';
import { toast } from "react-toastify";
import resetModemImg from '../../../../../asset/image/reset_modem.svg';
import alertIcon from "../../../../../asset/image/alert_icon.svg";
import amResetModem from "../../../../../asset/image/am-reset-modem.svg";
import resetModemGray from "../../../../../asset/image/reset_modem_gray.svg";
import simReloadGray from "../../../../../asset/image/sim_reload_gray.svg";
import simSwitchGray from "../../../../../asset/image/sim_switch_gray.svg";
import simSwitch2Gray from "../../../../../asset/image/sim_switch2_gray.svg";
import amReloadSim from "../../../../../asset/image/am-reload-sim.svg";
import amSim1 from "../../../../../asset/image/am-sim-1.svg";
import amSim2 from "../../../../../asset/image/am-sim-2.svg";
import amSimConnector from "../../../../../asset/image/am-sim-connector.svg";
import noSimIcon from "../../../../../asset/image/no_sim.svg";
import simIcon from '../../../../../asset/image/sim_icon.svg';
import simType1 from '../../../../../asset/image/sim_type_1.svg';
import vodafone from '../../../../../asset/image/vodafone.svg';
import verizon from '../../../../../asset/image/verizon.svg';
import tMobile from '../../../../../asset/image/t-mobile.svg';
import att from '../../../../../asset/image/att.svg';
import telefonica from '../../../../../asset/image/telefonica.svg';
import orange from '../../../../../asset/image/orange.svg';

import simType2 from '../../../../../asset/image/sim_type_2.svg';
import './cellularTab.css';
import _ from 'lodash';
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import SimCard from "../../components/SimCard/SimCard";
import SimDetails from "../../components/SimCard/SimDetails";
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from "../../components/InterfacesTable/NetworkTable/NetworkTable";
import TopBar from "../../../../../components/CommonComponents/TopBar";
import ModeInfoCard from "../../components/ModeInfoCard";
import { getAMdetails, getSimDetails, reloadSimDetails, resetModem, updateSimPriority, getSimPriorityDetails, updateSimDetails, triggerTowerScan, getTowerScanResult, getDeviceLinkStatusData } from "../../../../../actions/Users/authenticateOpenEdgeService";
import CommonModal from "../../components/Modals/CommonModal";
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import ScanResultPopup from "../../../../../components/PopUp/ScanResultPopup";

interface SimInfo {
    enabled: boolean;
    iccid: string;
    imsi?: string;
    user?: string;
    mode?: string;
    isEmpty?: boolean;
    roaming?: boolean;
}
interface TowerScanRow {
    mcc: string;
    mnc: string;
}

const carrierLogos = {
    verizon: {
        logo: verizon,
        height: 20
    },
    vodafone:{
        logo: vodafone,
        height: 30
    },
    telefonica:{
        logo: telefonica,
        height: 26
    },
    att:{
        logo: att,
        height: 35
    },
    orange:{
        logo: orange,
        height: 50
    },
    "t-mobile":{
        logo: tMobile,
        height: 20
    },
    "telefónica":{
        logo: telefonica,
        height: 26
    },
    "at&t":{
        logo: att,
        height: 35
    },
};

type SimsMap = Record<string, SimInfo>;
type SimOrderMap = Record<string, string>;

const getLoaderKey = (deviceId) => `CELLULAR_LOADER_STATE_${deviceId}`;
const getPollingKey = (deviceId) => `CELLULAR_POLLING_PAUSE_${deviceId}`;
const POLLING_INTERVAL = 50000; // 50 seconds

const CellularTab = (props) => {
    const dispatch = useDispatch();
    const isRestoringRef = useRef(false);
    const loaderTimeoutRef = useRef<any>(null);
    const actionInProgressRef = useRef(false); //prevents multiple 50s timers
    const fastPollingRef = useRef<any>(null);
    const fastPollingTimeoutRef = useRef<any>(null);
    const startFastPollingDelayRef = useRef<any>(null);

    const { selectedRow, getAMdetails, getSimDetails, modemDetails, simDetails, resetModemState, resetModem, reloadSim, reloadSimDetails, updateSimPriority, simPriorityDetails, setShowFooter, cellRef, getSimPriorityDetails, getSimPriorityStatus, fetchModemDetailsLoader, updateSimDetails, updatedSimSettings, triggerTowerScan, towerScan, towerScanResults, getTowerScanResult, getDeviceLinkStatusData, setSyncStatus, refreshIconClicked } = props;
    const [cellModemDetails, setCellModemDetails] = useState<any>({});
    const [sims, setSims] = useState<any>([]);
    const [activeSimStats, setActiveSimStats] = useState<any>({});
    const [openResetModal, setOpenResetModal] = useState(false);
    const [openReloadModal, setOpenReloadModal] = useState(false);
    const [openSimSwitchModal, setOpenSimSwitchModal] = useState<any>({ status: false, sim: {} });
    const [openSimSettingsModal, setOpenSimSettingsModal] = useState(false);
    const [modemStatus, setModemStatus] = useState<{ text: string, backgroundColor: string, color: string }>({ text: "Unknown", backgroundColor: "darkgray", color: "#fafafa" });
    const [simSettingMode, setSimSettingMode] = useState(false);
    const [prioritySims, setprioritySims] = useState<any>([]);
    const [selectedManualSim, setSelectedManualSim] = useState<any>({});
    const [showLoader, setShowLoader] = useState<any>({ status: false, loadingText: "" })
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [isScanning, setIsScanning] = useState<boolean>(false);
    const [towerData, setTowerData] = useState<TowerScanRow[]>([]);
    const [activeTab, setActiveTab] = useState("controller");
    
    const [loaderState, setLoaderState] = useState<any>({
        status: false,
        text: "Fetching SIM details...",
        subtext: "Please wait while we retrieve the latest information.",
        icon: ""
    });
    const segmentBarOptions = [
        { key: "Auto", value: "Auto" },
        { key: "Manual", value: "Manual" }
    ]
    const [selectedSegment, setSelectedSegment] = useState<any>('Auto');
    const [startTowerScanPolling, setStartTowerScanPolling] = useState(false);
    const [columns, setColumns] = useState<any>([
        {
            label: "SIM Slot",
            key: "slot",
            type: ColumnType.text,
            maxWidth: "25px",
        },
        {
            label: "Carrier",
            key: "operator",
            type: ColumnType.text,
            maxWidth: "100px",
        },
        {
            label: "IMSI",
            key: "imsi",
            type: ColumnType.text,
            maxWidth: "100px",
        },
        {
            label: "ICCID",
            key: "iccid",
            type: ColumnType.text,
            maxWidth: "110px",
        },
        {
            label: "APN",
            key: "apn",
            type: ColumnType.text,
            maxWidth: "90px",
        },
        {
            label: "Carrier Selection",
            key: "mode",
            type: ColumnType.text,
            maxWidth: "63px",
        },
        {
            label: "Roaming",
            key: "isRoaming",
            type: ColumnType.text,
            maxWidth: "63px",
        },
    ]);
    const [settingsSim, setSimSettings] = useState<any>({});
    const towerHeaders: { label: string; key: keyof TowerScanRow }[] = [
        { label: "MCC", key: "mcc" },
        { label: "MNC", key: "mnc" },
    ];

    const tabs = [
        { tabName: 'Controller', tabValue: 'controller', pathName: '/inventory' },
        { tabName: 'SIM Priority', tabValue: 'sim_settings', pathName: '/inventory' },
    ];

    const fetchCarrierLogo = (logo) => {
        return (
            <img src={carrierLogos[logo]?.logo} style={{height: carrierLogos[logo]?.height || 20, width:"auto"}} alt="" />
        )
    }

    const _getCarrierFallback = (carrierName) => {
        return (
            <div className="carrier-name-container">
                {carrierName || "Unknown"}
            </div>)
    }

    const fetchCarrier = (operator: string) => {
        if(Object.keys(carrierLogos).includes(operator)){
            return fetchCarrierLogo(operator?.toLowerCase())
        }else{
            return _getCarrierFallback(operator?.toLowerCase());
        }
    }

    const resetModemElement = (
        <div className="routerConfigDialogsContent">
            <img src={amResetModem} className="icons"></img>
            <div className="routerConfigDialogText">
                Cellular connectivity will be lost for some time during this operation.
            </div>
        </div>
    )

    const reloadSimElement = (
        <div className="routerConfigDialogsContent">
            <img src={amReloadSim} className="icons"></img>
            <div className="routerConfigDialogText">
                Cellular Service will be restarted upon SIM Reload.
            </div>
        </div>
    )

    const simSwitchElement = (
        <div className="routerConfigDialogsContent">
            <div className="sim-switch-icons">
                <img src={openSimSwitchModal?.sim?.id === "1" ? amSim2 : amSim1} alt="SIM 1" style={{ marginRight: '10px' }} />
                <img src={amSimConnector} alt="SIM Connector" style={{ marginRight: '10px' }} />
                <img src={openSimSwitchModal?.sim?.id === "1" ? amSim1 : amSim2} alt="SIM 2" />
            </div>
            <div className="routerConfigDialogText">
                {`You are about to Switch from SIM ${openSimSwitchModal?.sim?.id === "1" ? "2" : "1"} to SIM ${openSimSwitchModal?.sim?.id === "1" ? "1" : "2"}.`}<br></br>
                Modem will reboot to use New SIM.

            </div>
        </div>
    )

    const data = [
        { device: 'T mobile', iccid: '123456789', apn: 'test', data_plan: '10GB', activeBg: 'rgba(38, 76, 134, 1)', activeColor: 'rgba(255, 255, 255, 1)' },
        { device: 'Verizon', iccid: '123456789', apn: 'test', data_plan: '20GB', activeBg: 'rgba(217, 217, 217, 1)', activeColor: 'rgba(69, 70, 78, 1)' },
    ]

    const startFastPolling = () => {
        if (fastPollingRef.current) return;

        fastPollingRef.current = setInterval(() => {
            getAMdetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimPriorityDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
        }, 2000);

        // auto stop after 1.5 min
        fastPollingTimeoutRef.current = setTimeout(() => {
            stopFastPolling();
        }, 90000);
    };

    const stopFastPolling = () => {
        if (fastPollingRef.current) {
            clearInterval(fastPollingRef.current);
            fastPollingRef.current = null;
        }
        if (fastPollingTimeoutRef.current) {
            clearTimeout(fastPollingTimeoutRef.current);
            fastPollingTimeoutRef.current = null;
        }
        if (startFastPollingDelayRef.current) {
            clearTimeout(startFastPollingDelayRef.current);
            startFastPollingDelayRef.current = null;
        }
    };

    const scheduleFastPolling = (delayMs: number) => {
        if (startFastPollingDelayRef.current) {
            clearTimeout(startFastPollingDelayRef.current);
        }
        startFastPollingDelayRef.current = setTimeout(() => {
            startFastPollingDelayRef.current = null;
            startFastPolling();
        }, delayMs);
    };

    useEffect(() => {
        setShowLoader({ status: true });
        return () => {
            if (loaderTimeoutRef.current) {
                clearTimeout(loaderTimeoutRef.current);
            }
            stopFastPolling();
        };
    }, []);

    useEffect(() => {
        if (activeTab === "sim_settings") {
            setShowFooter(true);   // show footer
        } else {
            setShowFooter(false);  // hide footer
        }
    }, [activeTab]);


    const restoreLoaderState = () => {
        const loaderStateStr = localStorage.getItem(getLoaderKey(selectedRow?.deviceId));
        if (!loaderStateStr) return;

        const loader = JSON.parse(loaderStateStr);

        if (loader.expiresAt > Date.now()) {
            isRestoringRef.current = true;

            setLoaderState({
                status: true,
                text: loader.text,
                subtext: loader.subtext,
                icon: loader.icon,
            });
            setModemStatus({ text: "Not Available", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" });

            // Resume countdown correctly
            resumeLoaderTimeout(loader.expiresAt);
        } else {
            localStorage.removeItem(getLoaderKey(selectedRow?.deviceId));
            isRestoringRef.current = false;
            setLoaderState({ status: false, text: "", subtext: "", icon: "" });
        }
    };

    const doNavigateTab = (pathname, tabName) => {
      setActiveTab(tabName);
    }


    useEffect(() => {
        // restore on route entry (component mount)
        restoreLoaderState();

        // restore when browser tab regains focus
        const handleFocus = () => restoreLoaderState();
        window.addEventListener("focus", handleFocus);

        return () => {
            window.removeEventListener("focus", handleFocus);
        };
    }, []);

    useEffect(() => {
        let interval: any;

        const isPaused = () => {
            const pauseUntilStr = localStorage.getItem(getPollingKey(selectedRow?.deviceId));
            if (!pauseUntilStr) return false;

            const pauseUntil = Number(pauseUntilStr);

            if (Date.now() >= pauseUntil) {
                return false;
            }
            return true;
        };

        if (activeTab === "sim_settings") {
            return;
        }

        const fetchData = () => {
            const paused = isPaused();
            if (paused) return;
            getAMdetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimPriorityDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
        };
        fetchData();
        interval = setInterval(fetchData, 20000);

        return () => clearInterval(interval);
    }, [selectedRow?.k4Id, selectedRow?.deviceId, activeTab]);

    useEffect(() => {
        if (activeTab === "sim_settings") return;
        getDeviceLinkStatusData(selectedRow?.k4Id, selectedRow?.deviceId);
        const linkStatusInterval = setInterval(() => {
            getDeviceLinkStatusData(selectedRow?.k4Id, selectedRow?.deviceId);
        }, 5000);
        return () => clearInterval(linkStatusInterval);
    }, [selectedRow?.k4Id, selectedRow?.deviceId, activeTab]);

    useEffect(() => {
        if (refreshIconClicked) {
            getAMdetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getSimPriorityDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
            getDeviceLinkStatusData(selectedRow?.k4Id, selectedRow?.deviceId);
        }
    }, [refreshIconClicked]);

    const startLoaderTimeout = (time = POLLING_INTERVAL) => {
        // Prevent multiple timers
        if (actionInProgressRef.current) return;

        actionInProgressRef.current = true;

        if (loaderTimeoutRef.current) {
            clearTimeout(loaderTimeoutRef.current);
        }

        loaderTimeoutRef.current = setTimeout(() => {
            fetchFreshAfterTimeout();
        }, time);
    };

    const resumeLoaderTimeout = (expiresAt: number) => {
        const remaining = expiresAt - Date.now();

        if (remaining <= 0) {
            localStorage.removeItem(getLoaderKey(selectedRow?.deviceId));
            localStorage.removeItem(getPollingKey(selectedRow?.deviceId));
            isRestoringRef.current = false;
            return;
        }

        // prevent double timers
        if (actionInProgressRef.current) return;

        actionInProgressRef.current = true;

        loaderTimeoutRef.current = setTimeout(() => {
            fetchFreshAfterTimeout();
        }, remaining);
    };

    const fetchFreshAfterTimeout = () => {
        localStorage.removeItem(getLoaderKey(selectedRow?.deviceId));
        localStorage.removeItem(getPollingKey(selectedRow?.deviceId));

        isRestoringRef.current = false;
        actionInProgressRef.current = false;

        // Clear stale Redux values BEFORE releasing the loader guard so the
        // modemDetails/simDetails useEffects don't flash pre-switch data
        dispatch({ type: 'get_modem_details', payload: {} });
        dispatch({ type: 'get_sim_details', payload: {} });

        setLoaderState({
            status: false,
            text: "",
            subtext: "",
            icon: ""
        });

        getAMdetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
        getSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
        getSimPriorityDetails(selectedRow?.k4Id, selectedRow?.deviceId, {});
        getDeviceLinkStatusData(selectedRow?.k4Id, selectedRow?.deviceId);
    }


    const pausePollingFor50Sec = (time = POLLING_INTERVAL) => {
        const existing = localStorage.getItem(getPollingKey(selectedRow?.deviceId));

        if (existing && Number(existing) > Date.now()) {
            return; // already paused, do not extend
        }

        localStorage.setItem(
            getPollingKey(selectedRow?.deviceId),
            String(Date.now() + time)
        );
    };

    useEffect(() => {
        if (modemDetails !== undefined) {
            setShowLoader({ status: false, loadingText: "" });
        }

        if (loaderState.status || isRestoringRef.current || actionInProgressRef.current) return;

        if (!_.isEmpty(modemDetails)) {
            if (modemDetails?.data?.oe_response?.data) {
                setCellModemDetails(modemDetails?.data?.oe_response?.data);
                setModemStatus(getModemStateLabel(modemDetails?.data?.oe_response?.data?.state || 'unknown'));
                setLoaderState({ status: false, text: "", subtext: "", icon: "" });
                setSelectedSegment(modemDetails?.data?.oe_response?.data?.status === "manual" ? "Manual" : "Auto");
                modifyColumn(modemDetails?.data?.oe_response?.data?.status)
            } else {
                setShowLoader({ status: false, loadingText: "" });
                setCellModemDetails({});
                setModemStatus({ text: "Unknown", backgroundColor: "darkgray", color: "#fafafa" });
            }
        } else if (modemDetails !== undefined) {
            setShowLoader({ status: false, loadingText: "" });
            setCellModemDetails({});
            setModemStatus({ text: "Unknown", backgroundColor: "darkgray", color: "#fafafa" });
        }

    }, [modemDetails, loaderState?.status]);

    useEffect(() => {
        if (!setSyncStatus) return;
        const inProgressStates = ["Searching...", "Connecting...", "Verifying...", "Switching...", "Resetting..."];
        const stableStates = ["Connected", "Registered"];
        if (loaderState.status || inProgressStates.includes(modemStatus.text)) {
            setSyncStatus("Pending");
        } else if (!loaderState.status && stableStates.includes(modemStatus.text)) {
            setSyncStatus("Synced");
        }
    }, [modemStatus, loaderState?.status]);

    useEffect(() => {
        if (!fastPollingRef.current) return;
        const terminalStateLabels = ["Connected", "Registration Denied", "Error", "No SIM / Idle"];
        if (terminalStateLabels.includes(modemStatus.text)) {
            stopFastPolling();
        }
    }, [modemStatus]);

    const modifyColumn = (mode) => {
        const priorityColumn = {
            label: "SIM Priority",
            key: "order",
            type: ColumnType.orderColumn,
            maxWidth: "25px",
        };

        if (mode?.toLowerCase() === "auto") {
            //remove SIM Priority column
            setColumns(prev =>
                Array.isArray(prev)
                    ? prev.filter(col => col.key !== "order")
                    : prev
            );
        } else {
            //add SIM Priority only once
            setColumns(prev => {
                if (!Array.isArray(prev)) return prev;

                const alreadyExists = prev.some(col => col.key === "order");
                if (alreadyExists) return prev;

                return [
                    priorityColumn,
                    ...prev
                ];
            });
        }
    };

    useEffect(() => {
        if (loaderState.status || isRestoringRef.current || actionInProgressRef.current) return;
        if (!_.isEmpty(simDetails)) {
            setActiveSimStats(simDetails?.data?.oe_response?.data?.stats || {});
            const activeSimId = simDetails?.data?.oe_response?.data?.stats?.sim;

            let simArr = getOrderedSimList(
                simDetails?.data?.oe_response?.data?.sims || { sims: {} },
                simDetails?.data?.oe_response?.data?.sim_order || {}
            );

            const normalizedSimArr = [1, 2].map(slotId => {
                const found = simArr.find(sim => String(sim.id) === String(slotId));
                return found || {
                    id: slotId.toString(),
                    enabled: false,
                    iccid: '',
                    imsi: '',
                    user: '',
                    mode: '',
                    isEmpty: true
                };
            });

            const finalSimArr = normalizedSimArr.map(sim => ({
                ...sim,
                isRoaming: sim?.roaming ? "Enabled" : sim?.isEmpty ? "-" : "Disabled",
                activeBg: String(sim.id) === String(activeSimId)
                    ? 'rgba(38, 76, 134, 1)'
                    : 'rgba(217, 217, 217, 1)',
                activeColor: String(sim.id) === String(activeSimId)
                    ? 'rgba(255, 255, 255, 1)'
                    : 'rgba(69, 70, 78, 1)',
                slot: String(sim.id) === "1" ? "A" : "B",
                textTransform: "capitalize",
            }));

            setSims(finalSimArr);
            setprioritySims(finalSimArr);
            setLoaderState({ status: false, text: "", subtext: "", icon: "" });
        } else if (simDetails !== undefined) {
            setSims([]);
            setActiveSimStats({});
        }
    }, [simDetails, loaderState?.status]);

    const setLoadingState = (loaderData: any, isSwitch: string = "NA", time = POLLING_INTERVAL) => {
        setLoaderState({ status: true, ...loaderData });
        localStorage.setItem(getLoaderKey(selectedRow?.deviceId), JSON.stringify({ ...loaderData, expiresAt: Date.now() + time }));
        defaultState(isSwitch);
        pausePollingFor50Sec(time);
        startLoaderTimeout(time);
    }

    useEffect(() => {
        if (!_.isEmpty(resetModemState)) {
            if (resetModemState?.data?.oe_response?.success) {
                setOpenResetModal(false);
                const loaderData = {
                    text: "Resetting Modem…",
                    subtext: "Please wait while the modem reboots and applies the updated configuration.",
                    icon: resetModemGray
                };

                setLoadingState(loaderData, "NA");
                scheduleFastPolling(45000); 

                toast.success("Modem reset succesfully initiated.", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });

                dispatch({ type: "reset_modem", payload: {} });

            } else {
                toast.error(resetModemState?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
            }
        }
    }, [resetModemState]);

    useEffect(() => {
        if (!_.isEmpty(updatedSimSettings)) {
            if (updatedSimSettings?.data?.oe_response?.success) {
                setOpenSimSettingsModal(false);
                setTowerData([]);
                setAnchorEl(null);
                const loaderData = {
                    text: "Updating SIM…",
                    subtext: "Please wait while the modem reboots and applies the updated configuration.",
                    icon: resetModemGray
                };
                setLoadingState(loaderData, "NA");

                toast.success("SIM settings are being applied.", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });

                // Clear the reducer state immediately to prevent re-showing toast on navigation
                dispatch({ type: "update_sim_settings", payload: {} });

            } else {
                toast.error(updatedSimSettings?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
            }
        }
    }, [updatedSimSettings]);

    useEffect(() => {
        if (!_.isEmpty(reloadSim)) {
            if (reloadSim?.data?.oe_response?.success) {
                setOpenReloadModal(false);
                const loaderData = {
                    text: "Reloading SIM…",
                    subtext: "Modem is rebooting to apply the updated SIM settings.",
                    icon: simReloadGray
                };

                setLoadingState(loaderData, "NA", 110000); // SIM reload can take longer time
                scheduleFastPolling(110000); 

                toast.success("Sim reload initiated successfully.", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });

                dispatch({ type: "reload_sim_details", payload: {} });

            } else {
                toast.error(reloadSim?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
            }
        }
    }, [reloadSim]);

    useEffect(() => {
        modifyColumn(selectedSegment);
        if (!_.isEmpty(cellModemDetails) && cellModemDetails?.cellModemDetails?.status?.toLowerCase() !== selectedSegment?.toLowerCase()) {
            setSimSettingMode(true);
        }
    }, [selectedSegment]);


    useEffect(() => {
        if (cellRef) {
            cellRef.current = {
                saveSimPrioritySettings: async () => {
                    let mode = selectedSegment?.toLowerCase()
                    let payload = {
                        mode: mode,
                        sim: mode == "manual" ? selectedManualSim?.id ? selectedManualSim?.id : prioritySims[0]?.isEmpty? prioritySims[1]?.id: prioritySims[0]?.id : '',
                        iccid: mode == "manual" ? selectedManualSim?.iccid ? selectedManualSim?.iccid : prioritySims[0]?.isEmpty? prioritySims[1]?.iccid: prioritySims[0]?.iccid : '',
                    }

                    updateSimPriority(selectedRow?.k4Id, selectedRow?.deviceId, payload)

                }
            };
        }
    }, [activeTab, selectedSegment, selectedManualSim])

    useEffect(() => {
        if (!_.isEmpty(simPriorityDetails)) {
            if (simPriorityDetails?.data?.oe_response?.success) {
                let id = openSimSwitchModal?.sim?.id;
                setOpenSimSwitchModal({ status: false, sim: {} });
                const loaderData = {
                    text: "Switching SIM...",
                    subtext: "Modem will reboot to apply the new SIM settings.",
                    icon: id === "1" ? simSwitch2Gray : simSwitchGray
                };

                setLoadingState(loaderData, "switch");
                scheduleFastPolling(45000); 

                toast.success("SIM switch initiated successfully.", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });

                dispatch({ type: "update_sim_priority_details", payload: {} });

            } else {
                toast.error(simPriorityDetails?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
            }
        }
    }, [simPriorityDetails]);

    const defaultState = (state) => {
        setSims([]); // Clear SIMs during reset
        setprioritySims([]);
        setCellModemDetails({});
        if (state === "switch") {
            setModemStatus({ text: "Switching...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" });
        } else {
            setModemStatus({ text: "Not Available", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" });

        }
    }

    const getOrderedSimList = (sims: SimsMap, simorder: SimOrderMap) => {
        if (!simorder || Object.keys(simorder).length === 0) {
            return [];
        }
        const result: (SimInfo & { id: string })[] = [];

        Object.entries(simorder).forEach(([orderKey, iccid]) => {
            const simDetails = sims[iccid]; // no type error now

            if (simDetails) {
                result.push({
                    id: orderKey,
                    ...simDetails
                });
            }
        });

        return result;
    };

    const getModemStateLabel = (state) => {
        const stateLabelMap = {
            unavailable: { text: "Not Available", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" },
            idle: { text: "No SIM / Idle", backgroundColor: "rgba(38, 76, 134, 1)", color: "#fafafa" },
            searching: { text: "Searching...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },
            registered: { text: "Registered", backgroundColor: "rgba(41, 183, 90, 1)", color: "#fafafa" },
            connecting: { text: "Connecting...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },
            verifying: { text: "Verifying...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },
            connected: { text: "Connected", backgroundColor: "rgba(41, 183, 90, 1)", color: "#fafafa" },
            denied: { text: "Registration Denied", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" },
            error: { text: "Error", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" },
            switching: { text: "Switching...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },
            resetting: { text: "Resetting...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },
            "no sim available": { text: "Not Available", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" },
            probing: { text: "Connecting...", backgroundColor: "rgba(246, 173, 1, 1)", color: "#fafafa" },

        };

        return stateLabelMap[state] || { text: "Unknown", backgroundColor: "rgba(199, 67, 43, 1)", color: "#fafafa" };
    }

    const sortedSimsBasedPriority = [...sims].sort((a, b) => {
        if (a.priority === b.priority) {
            // Sort by id as fallback
            return Number(a.id) - Number(b.id);
        }

        return b.priority - a.priority;
    });

    const handleDragDropRow = (draggedRow, newPriority) => {

        const updated = [...prioritySims];

        const oldIndex = updated.findIndex(
            row => row.iccid === draggedRow.iccid
        );

        const [moved] = updated.splice(oldIndex, 1);
        // newPriority is 1-based (matches row.order from NetworkTable), so convert to a 0-based splice index.
        updated.splice(newPriority - 1, 0, moved);

        setprioritySims(updated);

        setSelectedManualSim(updated[0]);
    };

    const simTableWrapperRef = useRef<HTMLDivElement>(null);
    const draggedSimRowRef = useRef<{ index: number; row: any } | null>(null);

    // NetworkTable only wires drag/drop listeners onto its small drag-handle cell, so dropping
    // anywhere else on a row (or below the last row) is silently rejected by the browser. These
    // wrapper-level listeners widen the drop zone to the whole table area without touching the
    // shared NetworkTable component.
    const handleSimTableDragStartCapture = (e: React.DragEvent<HTMLDivElement>) => {
        const rowEl = (e.target as HTMLElement).closest("tbody tr");
        const wrapperEl = simTableWrapperRef.current;
        if (!rowEl || !wrapperEl) return;

        const rows = Array.from(wrapperEl.querySelectorAll("tbody tr"));
        const index = rows.indexOf(rowEl);
        const visibleSims = prioritySims.filter(el => !el.isEmpty);
        if (index === -1 || !visibleSims[index]) return;

        draggedSimRowRef.current = { index, row: visibleSims[index] };
    };

    const handleSimTableDropCapture = (e: React.DragEvent<HTMLDivElement>) => {
        // A drop landing directly on NetworkTable's own drag-handle is already handled internally.
        if ((e.target as HTMLElement).closest('[draggable="true"]')) return;

        const dragged = draggedSimRowRef.current;
        const wrapperEl = simTableWrapperRef.current;
        draggedSimRowRef.current = null;
        if (!dragged || !wrapperEl) return;

        e.preventDefault();

        const rows = Array.from(wrapperEl.querySelectorAll("tbody tr")) as HTMLElement[];
        let targetIndex = rows.length;
        for (let i = 0; i < rows.length; i++) {
            const rect = rows[i].getBoundingClientRect();
            if (e.clientY < rect.top + rect.height / 2) {
                targetIndex = i;
                break;
            }
        }

        const finalIndex = dragged.index < targetIndex ? targetIndex - 1 : targetIndex;
        if (finalIndex === dragged.index) return;

        handleDragDropRow(dragged.row, finalIndex + 1);
    };

    const handleSimTableDragEndCapture = () => {
        draggedSimRowRef.current = null;
    };

    const toList = (value) => {
        if (!value) return [];

        // If already an array, clean and return
        if (Array.isArray(value)) {
            return value
                .map(v => String(v).trim())
                .filter(v => v.length > 0);
        }

        // Force string conversion for safety
        const str = String(value).trim();
        if (str === "") return [];

        return str
            .split(",")
            .map(item => item.trim())
            .filter(item => item !== "");
    };

    const getMatchingValues = (arr1, arr2) => {
        return arr1.filter(value => arr2.includes(value));
    }

    // MCC/MNC codes are numeric; strip anything that isn't a digit, comma or whitespace.
    const sanitizeNumericList = (value) => value.replace(/[^0-9,\s]/g, "");

    const handleUpdateSimDetails = () => {
        let duplicates = getMatchingValues(toList(settingsSim?.allow), toList(settingsSim?.block))
        if (settingsSim.mode === "manual" && _.isEmpty(settingsSim.carrier)) {
            toast.error("Enter MCC/MNC value", {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            return;
        }
        else if (duplicates.length > 0) {
            toast.error(`Allow list and Block list cannot have the same values: ${duplicates?.join(', ')}`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            return;
        }
        const payload = {
            imsi: settingsSim.imsi ? settingsSim.imsi : "",
            iccid: settingsSim.iccid ? settingsSim.iccid : "",
            apn: settingsSim.apn ? settingsSim.apn : "",
            user: settingsSim.user || "",
            password: settingsSim.password || "",
            roaming: settingsSim.roaming || false,
            allow: toList(settingsSim.allow),
            block: toList(settingsSim.block),
            mode: settingsSim.mode,
            carrier: settingsSim.mode === "manual" ? settingsSim.carrier : "",
            enabled: settingsSim.enabled
        }
        updateSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, payload);
    };

    useEffect(() => {
        if (!_.isEmpty(towerScan)) {
            if (towerScan?.data?.oe_response?.success) {
                setIsScanning(true);
                setStartTowerScanPolling(true);
                pausePollingFor50Sec();

            } else {
                toast.error(towerScan?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                })
            }
        }
    }, [towerScan])

    useEffect(() => {
        if (!startTowerScanPolling) return;

        getTowerScanResult(selectedRow?.k4Id, selectedRow?.deviceId, {}); // immediate call

        const interval = setInterval(() => {
            getTowerScanResult(selectedRow?.k4Id, selectedRow?.deviceId, {});
        }, 15000);

        return () => clearInterval(interval);
    }, [startTowerScanPolling]);

    useEffect(() => {
        if (!_.isEmpty(towerScanResults)) {
            if (towerScanResults?.data?.oe_response?.success) {
                if (towerScanResults?.data?.oe_response?.data.scan == false) {
                    if (towerScanResults?.data?.oe_response?.data?.scanResults) {
                        setIsScanning(false);
                        setStartTowerScanPolling(false);
                        const rawData: TowerScanRow[] = towerScanResults?.data?.oe_response?.data?.scanResults || [];
                        const uniqueTowerData = Array.from(
                            new Map(
                                rawData.map(item => [
                                    `${item.mcc}-${item.mnc}`,
                                    item
                                ])
                            ).values()
                        );
                        setTowerData(uniqueTowerData);
                    } else {
                        setTowerData([]); // optional: clear old data
                    }
                }
            } else {
                toast.error(towerScanResults?.data?.oe_response?.data, {
                    position: toast.POSITION.BOTTOM_LEFT,
                })
            }
        }
    }, [towerScanResults])

     useEffect(() => {
        if (!_.isEmpty(simPriorityDetails)) {
          if (simPriorityDetails?.data?.oe_response?.success) {
            doNavigateTab("", "controller")
          }else {
            toast.error(simPriorityDetails?.data?.oe_response?.data, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
        }
        }
      }, [simPriorityDetails])

    return (

        <div className="internalPadding cellular-tab-container">
            {
                selectedRow?.licenseTier === "T101" || selectedRow?.licenseTier === "T103" ?
                    <Grid container className="controller-grid-container">
                        <Grid xs={12} className="controller-grid">
                            <div className="no-sim-container" style={{ height: '370px' }}>
                                <img src={upgrade_license} style={{ height: "58px", width: "58px" }} alt="No SIM" />
                                <Typography variant="body2" color="text.secondary">
                                    Upgrade to a Standard Router License or higher to access Cellular features.
                                </Typography>
                            </div>
                        </Grid>

                    </Grid>
                    :
                    <>
                        <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
                        {activeTab == 'controller' && <Grid container className="controller-grid-container" style={{ marginLeft: "1px" }} spacing={1} mt={1}>
                            <Grid item xs={12} sm={5} md={4} lg={3} className="controller-grid">
                                <div className="justify-icons-between">
                                    <Tooltip title={<span style={{ fontSize: "12px" }}>Reset Modem</span>}>
                                        <img className="active-link" src={resetModemImg} alt="Modem Reset" onClick={() => setOpenResetModal(true)} />
                                    </Tooltip>

                                    <button style={{ background: modemStatus.backgroundColor, color: modemStatus.color }} className="connected-btn">{modemStatus.text}</button>
                                    <Tooltip title={<span style={{ fontSize: "12px" }}>Reload SIM</span>}>
                                        <img className="active-link" src={simIcon} alt="Reload SIM" onClick={() => setOpenReloadModal(true)} />
                                    </Tooltip>

                                </div>
                                <div className="justify-icons-center">
                                    {fetchCarrier(cellModemDetails?.operator || "")}
                                </div>
                                <LabelValueDisplay
                                    label="Model"
                                    value={cellModemDetails?.model || '--'}
                                />
                                <LabelValueDisplay
                                    label="IMEI"
                                    value={cellModemDetails?.imei || '--'}
                                />
                                <LabelValueDisplay
                                    label="Firmware"
                                    value={cellModemDetails?.firmware || '--'}
                                />
                                <LabelValueDisplay
                                    label="Serial / DID"
                                    value={cellModemDetails?.serialno || '--'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={7} md={8} lg={9} pr={1}>
                                {
                                    sims.length > 0 ?
                                        <Grid container spacing={1}>
                                            {
                                                sims.map((sim, index) => (
                                                    <Grid item xs={12} sm={12} md={6} lg={6} className="no-padding-top">
                                                        <SimCard
                                                            status={activeSimStats.iccid === sim.iccid ? "Active" : sim.isEmpty ? "No SIM" : "Standby"}
                                                            simLabel={sim.id === '1' ? 'SIM A' : sim.id === '2' ? 'SIM B' : 'SIM'}
                                                            modemConnected={activeSimStats.state === "connected" || activeSimStats.state === "registered"}
                                                            provider={sim.operator || '--'}
                                                            iccid={sim.iccid || '--'}
                                                            apn={sim.apn || '--'}
                                                            usage={sim.usage || 0}
                                                            limit={sim.limit || 0}
                                                            uptime={sim.uptime || '--'}
                                                            isPriority={sim.priority ? true : false}
                                                            color="green"
                                                            isLocked={!sim.enabled}
                                                            onClick={() => sim.enabled ? setOpenSimSwitchModal({ status: true, sim: sim }) : undefined}
                                                            onSimSettingClick={() => {
                                                                setSimSettings(sim);
                                                                setOpenSimSettingsModal(true);
                                                            }}
                                                            isEmpty={sim.isEmpty || false}
                                                        />
                                                    </Grid>
                                                ))
                                            }

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <SimDetails simData={cellModemDetails} />
                                            </Grid>
                                        </Grid>
                                        :
                                        loaderState.status ?
                                            <div className="no-sim-container">
                                                <img src={loaderState.icon ? loaderState.icon : noSimIcon} style={{ height: "auto", width: "200px" }} alt="No SIM" />
                                                <Typography variant="body2" color="text.secondary">
                                                    {loaderState.text ? loaderState.text : "No SIM cards detected."}</Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {loaderState.subtext ? loaderState.subtext : "Insert SIM cards to configure cellular connectivity information."}
                                                </Typography>
                                            </div>
                                            :
                                            <div className="no-sim-container">
                                                <img src={noSimIcon} style={{ height: "58px", width: "58px" }} alt="No SIM" />
                                                <Typography variant="body2" color="text.secondary">
                                                    Fetching SIM details...<br></br>

                                                    Please wait while we retrieve the latest information.
                                                </Typography>
                                            </div>
                                }

                            </Grid>
                        </Grid>}
                        {activeTab == 'sim_settings' && <Grid className="controller-grid-container" mt={2}>
                            <div
                                ref={simTableWrapperRef}
                                onDragOver={(e) => e.preventDefault()}
                                onDragStartCapture={handleSimTableDragStartCapture}
                                onDrop={handleSimTableDropCapture}
                                onDragEnd={handleSimTableDragEndCapture}
                            >
                                <NetworkTable
                                    data={prioritySims.filter(el => !el.isEmpty)}
                                    columns={columns}
                                    action="setting"
                                    onDragDropRow={handleDragDropRow}

                                />
                            </div>
                            <Grid>
                                <TopBar showSegmentedButton={true} selectedSegment={selectedSegment} setSelectedSegment={setSelectedSegment} segmentBarOptions={segmentBarOptions} justifySegment='center' />
                            </Grid>
                            {selectedSegment == 'Auto' ? <ModeInfoCard
                                title="Auto SIM"
                                description={[
                                    "SIMs are treated equally.",
                                    "Your device will stay on the current SIM unless it loses signal, then switch to another available SIM.",
                                ]}
                            /> : <ModeInfoCard
                                title="Manual"
                                description={[
                                    "Drag to set SIM priority.",
                                    "The device will stay on the selected SIM even if it becomes unreachable.", "It will not switch to another SIM automatically.",
                                ]}
                            />}

                        </Grid>}
                        {openResetModal &&
                            <CommonModal
                                open={openResetModal}
                                onClose={() => setOpenResetModal(false)}
                                onSave={() => resetModem(selectedRow?.k4Id, selectedRow?.deviceId, {})}
                                title={"Reset Modem"}
                                saveText={"Reset"}
                                showOnlineOffline={false}
                                showSyncStatus={false}
                                children={resetModemElement}
                                width={"408px"}
                                height={"320px"}
                                showCancel={true}
                                titleWithWarningIcon={false}
                                titleWithCustomIcon={true}
                                customIcon={alertIcon}
                            />
                        }
                        {openReloadModal &&
                            <CommonModal
                                open={openReloadModal}
                                onClose={() => setOpenReloadModal(false)}
                                onSave={() => reloadSimDetails(selectedRow?.k4Id, selectedRow?.deviceId, {})}
                                title={"Reload SIM"}
                                saveText={"Reload"}
                                showOnlineOffline={false}
                                showSyncStatus={false}
                                children={reloadSimElement}
                                width={"408px"}
                                height={"320px"}
                                showCancel={true}
                                titleWithWarningIcon={false}
                                titleWithCustomIcon={true}
                                customIcon={alertIcon}
                            />
                        }
                        {
                            openSimSwitchModal?.status &&
                            <CommonModal
                                open={openSimSwitchModal?.status}
                                onClose={() => setOpenSimSwitchModal({ status: false, sim: {} })}
                                onSave={() => updateSimPriority(selectedRow?.k4Id, selectedRow?.deviceId, { mode: cellModemDetails?.status, sim: openSimSwitchModal?.sim?.id, iccid: openSimSwitchModal?.sim?.iccid })}
                                title={"SIM Switch"}
                                saveText={"Proceed"}
                                showOnlineOffline={false}
                                showSyncStatus={false}
                                children={simSwitchElement}
                                width={"408px"}
                                height={"320px"}
                                showCancel={true}
                                titleWithWarningIcon={false}
                                titleWithCustomIcon={true}
                                customIcon={alertIcon}
                            />
                        }
                        {openSimSettingsModal &&
                            <AddEditInterfaceModal
                                open={openSimSettingsModal}
                                onClose={() => { setOpenSimSettingsModal(false); setTowerData([]); setAnchorEl(null); }}
                                onSave={() => { handleUpdateSimDetails() }}
                                title={settingsSim?.operator?.replace(/\b\w/g, c => c.toUpperCase()) || settingsSim?.operator}
                                saveText="Save"
                                width="808px"
                                maxWidth="808px"
                                // disableSave={selectedTerminals === null}
                                layout={[
                                    {
                                        columns: [
                                            {
                                                component: (
                                                    <div style={{ padding: "5px 10px 5px 10px", border: "1px solid #D0D1DC", borderRadius: "10px" }}>
                                                        <div className="toggle-container">
                                                            <div>
                                                                <div className="toggle-label">SIM</div>
                                                            </div>
                                                            <div>
                                                                <label className="if-switch-toggle">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={settingsSim.enabled}
                                                                        onChange={(e) => {
                                                                            setSimSettings((prev) => ({
                                                                                ...prev,
                                                                                enabled: e?.target?.checked === true ? true : false
                                                                            }));
                                                                        }}
                                                                    />
                                                                    <span className="if-slider-toggle" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="toggle-container">
                                                            <div>
                                                                <div className="toggle-label">Data Roaming</div>
                                                            </div>
                                                            <div>
                                                                <label className="if-switch-toggle">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={settingsSim.roaming}
                                                                        onChange={(e) => {
                                                                            setSimSettings((prev) => ({
                                                                                ...prev,
                                                                                roaming: e?.target?.checked
                                                                            }));
                                                                        }}
                                                                    />
                                                                    <span className="if-slider-toggle" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginTop: "15px" }}>
                                                            <LabelValueDisplay
                                                                label="IMSI"
                                                                value={settingsSim.imsi ? settingsSim.imsi : ""}
                                                                flexDirection="row"
                                                            />
                                                        </div>
                                                        <div style={{ marginTop: "15px" }}>
                                                            <LabelValueDisplay
                                                                label="ICCID (1)"
                                                                value={settingsSim.iccid}
                                                                flexDirection="row"
                                                            />
                                                        </div>
                                                        <div style={{ marginTop: "12px" }}>
                                                            <ToggleSwitch
                                                                label="Carrier Selection"
                                                                description=""
                                                                checked={settingsSim.mode === 'auto' ? false : true}
                                                                onChange={(checked) => {
                                                                    setSimSettings(prev => ({
                                                                        ...prev,
                                                                        mode: checked ? "manual" : "auto"
                                                                    }));
                                                                }}
                                                                trueLabel="Manual"
                                                                falseLabel="Auto"
                                                                width={"70px"}
                                                                bothEnabledLabels={true}
                                                                topMargin={"0px"}
                                                            />
                                                        </div>
                                                        <Grid container spacing={1.5} style={{ marginTop: "8px" }}>
                                                            <Grid item xs={6}>
                                                                <LabelValueDisplay
                                                                    label="Set MCC/MNC"
                                                                    isInput
                                                                    value={
                                                                        settingsSim?.carrier?.length > 3
                                                                            ? `${settingsSim?.carrier?.slice(0, 3)}/${settingsSim?.carrier?.slice(3, 6)}`
                                                                            : settingsSim?.carrier
                                                                    }
                                                                    onChange={(e) => {
                                                                        let raw = e.target.value.replace(/\D/g, ""); // only digits

                                                                        if (raw.length > 6) return; //block extra input

                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            carrier: raw
                                                                        }));
                                                                    }}
                                                                    disabled={settingsSim.mode === 'auto'}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <LabelValueDisplay
                                                                    label="Scan Output"
                                                                    customComponent={
                                                                        <div>
                                                                            <Button
                                                                                variant="outlined"
                                                                                component="span"
                                                                                className='csv-upload--button_outlined_filter select-csv-button'
                                                                                style={{ padding: "1px 18px", textTransform: "none", width: "auto" }}
                                                                                disabled={isScanning || settingsSim.mode === 'auto'}
                                                                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                                                    if (_.isEmpty(towerData)) {
                                                                                        triggerTowerScan(selectedRow?.k4Id, selectedRow?.deviceId, {});
                                                                                        setIsScanning(true);
                                                                                    }
                                                                                    setAnchorEl(e.currentTarget);
                                                                                }}
                                                                            >
                                                                                {isScanning ? "Scanning.." : "Towerscan"}
                                                                            </Button>
                                                                            <ScanResultPopup<TowerScanRow>
                                                                                open={Boolean(anchorEl)}
                                                                                anchorEl={anchorEl}
                                                                                headers={towerHeaders}
                                                                                data={towerData}
                                                                                loading={isScanning}
                                                                                skeletonRows={4}
                                                                                skeletonColumns={2}
                                                                                onClose={() => setAnchorEl(null)}
                                                                                onRowClick={(data) =>
                                                                                    setSimSettings(prev => ({
                                                                                        ...prev,
                                                                                        carrier: `${data.mcc}${data.mnc}`
                                                                                    }))}
                                                                            />

                                                                        </div>
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                ),
                                                gridSize: 4,
                                            },
                                            {
                                                component: (
                                                    <div style={{ padding: "5px 10px 5px 10px", border: "1px solid #D0D1DC", height: "270px", borderRadius: "10px" }}>
                                                        <Grid container spacing={1.5}>
                                                            <Grid item xs={4}>
                                                                <LabelValueDisplay
                                                                    label="APN"
                                                                    isInput
                                                                    value={settingsSim.apn}
                                                                    onChange={(e) => {
                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            apn: e.target.value
                                                                        }));
                                                                    }}
                                                                    placeholder="Enter APN"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <LabelValueDisplay
                                                                    label="Username"
                                                                    isInput
                                                                    value={settingsSim.user}
                                                                    onChange={(e) => {
                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            user: e.target.value
                                                                        }));
                                                                    }}
                                                                    readOnly={true}
                                                                    onFocus={(e) => e.target.removeAttribute('readonly')}
                                                                    placeholder="Enter Username"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <LabelValueDisplay
                                                                    label="Password"
                                                                    isInput
                                                                    value={settingsSim.password}
                                                                    onChange={(e) => {
                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            password: e.target.value
                                                                        }));
                                                                    }}
                                                                    placeholder="Enter Password"
                                                                    isPassword={true}
                                                                    passwordClass={true}
                                                                    readOnly={true}
                                                                    onFocus={(e) => e.target.removeAttribute('readonly')}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={1.5}>
                                                            <Grid item xs={12} style={{ marginTop: "2px" }}>
                                                                <LabelValueDisplay
                                                                    label="Block List"
                                                                    isInput
                                                                    value={settingsSim.block}
                                                                    onChange={(e) => {
                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            block: sanitizeNumericList(e.target.value)
                                                                        }));
                                                                    }}
                                                                    placeholder="e.g. 330, 331, 420"
                                                                    isMultiline={true}
                                                                    textInputRows={5}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={1.5} style={{ marginTop: "48px" }}>
                                                            <Grid item xs={12}>
                                                                <LabelValueDisplay
                                                                    label="Allow List"
                                                                    isInput
                                                                    value={settingsSim.allow}
                                                                    onChange={(e) => {
                                                                        setSimSettings(prev => ({
                                                                            ...prev,
                                                                            allow: sanitizeNumericList(e.target.value)
                                                                        }));
                                                                    }}
                                                                    placeholder="e.g. 330, 331, 420"
                                                                    isMultiline={true}
                                                                    textInputRows={5}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                ),
                                                gridSize: 8,
                                            },
                                        ],
                                    },
                                ]}
                            />
                        }
                    </>
            }
            {fetchModemDetailsLoader && showLoader.status &&
                <CustomLoader
                    showLoader={true}
                    loadingText={
                        "Please wait..."
                    }
                />
            }

        </div>
    )
}

const mapStateToProps = (state) => ({
    modemDetails: state.authReducer.modemDetails,
    simDetails: state.authReducer.simDetails,
    resetModemState: state.authReducer.resetModemState,
    reloadSim: state.authReducer.reloadSim,
    simPriorityDetails: state.authReducer.simPriorityDetails,
    getSimPriorityStatus: state.authReducer.getSimPriorityStatus,
    fetchModemDetailsLoader: state.authReducer.fetchModemDetailsLoader,
    updatedSimSettings: state.authReducer.updatedSimSettings,
    towerScan: state.authReducer.towerScan,
    towerScanResults: state.authReducer.towerScanResults
});

export default withRouter(
    connect(mapStateToProps, { getAMdetails, getSimDetails, reloadSimDetails, resetModem, updateSimPriority, getSimPriorityDetails, updateSimDetails, triggerTowerScan, getTowerScanResult, getDeviceLinkStatusData })(CellularTab)
);